export default "<div class=\"phoenix\">\n  <lib-toast-notification></lib-toast-notification>\n  <router-outlet></router-outlet>\n</div>\n"